$(function(){
    sessionStorage.removeItem('recommend_products_ids');
    sessionStorage.removeItem('recommend_card_id');
    sessionStorage.removeItem('recommend_products');
    window.intelligent_recommend( clientId , email);
    $('.more a').on('click', function (event) {
        event.preventDefault();
         // 直接将页面滚动到顶部
       $('html, body').scrollTop(0);
    })
})
    // 监听滚动事件
    var scrollThreshold = 200; // 滚动的阈值，每滚动200像素调用一次函数
    var jiazai_num=0;
    // 滚动事件处理函数
    var lastScrollTop = $('.blackFriday_active_second').offset().top-1000;
    function scrollEventHandler() {
        if (!allowScrollHandler) {
            return;
        }
        // 获取当前滚动条的位置
       let scrollTop =  $(window).scrollTop();
        // 判断滚动的距离是否超过阈值，并且是向下滚动
            // 在这里编写原来的滚动事件处理逻辑
        if (scrollTop > lastScrollTop && (scrollTop - lastScrollTop) >= scrollThreshold) {
          jiazai_num+=1;
            // 调用需要执行的函数
            // 更新上次滚动的位置
            console.log('加载次数',jiazai_num);
            if(jiazai_num<8){
              lastScrollTop = $(window).scrollTop();
              window.intelligent_recommend( clientId , email);
            }
 
        }
    }